import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "products-error",
  class: "record-table__message"
}
const _hoisted_2 = {
  key: 1,
  "data-test": "products-empty",
  class: "record-table__message"
}
const _hoisted_3 = {
  key: 2,
  class: "record-table__scroll"
}
const _hoisted_4 = { class: "record-table" }
const _hoisted_5 = { scope: "col" }
const _hoisted_6 = {
  scope: "col",
  class: "record-table__num"
}
const _hoisted_7 = {
  scope: "col",
  class: "record-table__num"
}
const _hoisted_8 = {
  scope: "col",
  class: "record-table__num"
}
const _hoisted_9 = {
  scope: "col",
  class: "record-table__num products__share-col"
}
const _hoisted_10 = {
  scope: "col",
  class: "record-table__num"
}
const _hoisted_11 = ["data-label"]
const _hoisted_12 = { class: "products__product" }
const _hoisted_13 = ["data-initials"]
const _hoisted_14 = { class: "break-words" }
const _hoisted_15 = ["data-label"]
const _hoisted_16 = ["data-label"]
const _hoisted_17 = ["data-label"]
const _hoisted_18 = ["data-label"]
const _hoisted_19 = { class: "products__share" }
const _hoisted_20 = {
  class: "products__track",
  "aria-hidden": "true"
}
const _hoisted_21 = ["data-label"]
const _hoisted_22 = {
  "data-test": "products-summary",
  class: "tabular-nums"
}

import { computed, ref, watch } from 'vue'

import RecordTableCard from '@/components/customers/record/RecordTableCard.vue'
import ReportDateRangeFilter from '@/components/reports/ReportDateRangeFilter.vue'
import { useReportDateRange } from '@/composables/useReportDateRange'
import { formatServerDay } from '@/helpers/dates'
import { productInitials } from '@/helpers/initials'
import { formatDollars } from '@/helpers/money'
import { ALL_TIME_OPTION, DATE_RANGE_OPTIONS } from '@/helpers/reportDateRanges'
import api from '@/store/api'


export default {
  __name: 'CustomerProductsOrdered',
  props: {
  conversationUserPairId: { type: String, required: true },
  range: { type: Object, default: null },
  title: { type: String, default: 'Products ordered' },
  hideWhenNeverOrdered: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const PRODUCTS_DATE_RANGE_OPTIONS = [ALL_TIME_OPTION, ...DATE_RANGE_OPTIONS]

const LABELS = {
  product: 'Product',
  orders: 'Orders',
  count: 'Qty',
  revenue: 'Revenue',
  share: 'Share',
  lastOrdered: 'Last ordered'
}

const NO_SHARE = { label: '-', width: '0%' }

const formatCents = cents => formatDollars((cents || 0) / 100)

const { selectedDateRange, selectedDateRangeLabel, customDateRange, setDateRange, apiDateRange } = useReportDateRange(
  ALL_TIME_OPTION.value
)

const rows = ref([])
const summary = ref({ orders_count: 0, revenue_cents: 0 })
const loading = ref(false)
const loaded = ref(false)
const loadFailed = ref(false)

const isAllTime = computed(() => selectedDateRange.value === ALL_TIME_OPTION.value && !customDateRange.value)

const neverOrdered = computed(
  () => loaded.value && !loadFailed.value && !props.range && isAllTime.value && rows.value.length === 0
)

const hidden = computed(() => props.hideWhenNeverOrdered && (!loaded.value || neverOrdered.value))

const summaryLabel = computed(() => {
  const count = summary.value.orders_count
  return `${count} ${count === 1 ? 'order' : 'orders'}, ${formatCents(summary.value.revenue_cents)} in products`
})

const shareOf = row => {
  const total = summary.value.revenue_cents
  if (!total || total <= 0) return NO_SHARE
  const percent = (row.revenue_cents / total) * 100
  return {
    label: percent > 0 && percent < 1 ? '<1%' : `${Math.round(percent)}%`,
    width: `${percent.toFixed(1)}%`
  }
}

const tableRows = computed(() =>
  rows.value.map(row => ({ ...row, initials: productInitials(row.product_name), share: shareOf(row) }))
)

const requestRange = () => props.range ?? (isAllTime.value ? null : apiDateRange())

const requestQuery = () => {
  const params = new URLSearchParams({ conversation_user_pair_id: props.conversationUserPairId })
  const range = requestRange()
  if (range) {
    params.append('beginning_date', range.beginning_date)
    params.append('ending_date', range.ending_date)
  }
  return params.toString()
}

let latestRequest = 0

const fetchProducts = async () => {
  const request = ++latestRequest
  loading.value = true
  try {
    const res = await api.call(
      'GET',
      `data_downloads/reports/customer_products_report?${requestQuery()}`,
      {},
      { receive: false }
    )
    if (request === latestRequest) {
      rows.value = res?.data?.data?.table?.rows ?? []
      summary.value = res?.data?.data?.summary ?? { orders_count: 0, revenue_cents: 0 }
      loadFailed.value = false
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching customer products:', error)
    if (request === latestRequest) {
      loadFailed.value = true
      rows.value = []
      summary.value = { orders_count: 0, revenue_cents: 0 }
    }
  } finally {
    if (request === latestRequest) {
      loading.value = false
      loaded.value = true
    }
  }
}

const onDateRangeChange = value => {
  setDateRange(value)
  fetchProducts()
}

watch(() => [props.conversationUserPairId, props.range], fetchProducts, { immediate: true })

return (_ctx, _cache) => {
  return (!hidden.value)
    ? (_openBlock(), _createBlock(RecordTableCard, {
        key: 0,
        "data-test": "products-ordered",
        title: __props.title
      }, _createSlots({
        default: _withCtx(() => [
          (!loading.value && loadFailed.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Couldn't load products. Please try again. "))
            : (!loading.value && rows.value.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " No products ordered in this period "))
              : (rows.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("table", _hoisted_4, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_5, _toDisplayString(LABELS.product), 1),
                          _createElementVNode("th", _hoisted_6, _toDisplayString(LABELS.orders), 1),
                          _createElementVNode("th", _hoisted_7, _toDisplayString(LABELS.count), 1),
                          _createElementVNode("th", _hoisted_8, _toDisplayString(LABELS.revenue), 1),
                          _createElementVNode("th", _hoisted_9, _toDisplayString(LABELS.share), 1),
                          _createElementVNode("th", _hoisted_10, _toDisplayString(LABELS.lastOrdered), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableRows.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.product_id,
                            "data-test": "product-row"
                          }, [
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.product,
                              class: "record-table__primary"
                            }, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", {
                                  class: "products__swatch",
                                  "data-initials": row.initials,
                                  "aria-hidden": "true"
                                }, null, 8, _hoisted_13),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(row.product_name), 1)
                              ])
                            ], 8, _hoisted_11),
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.orders,
                              class: "record-table__num"
                            }, _toDisplayString(row.orders), 9, _hoisted_15),
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.count,
                              class: "record-table__num"
                            }, _toDisplayString(row.count), 9, _hoisted_16),
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.revenue,
                              class: "record-table__num"
                            }, _toDisplayString(formatCents(row.revenue_cents)), 9, _hoisted_17),
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.share,
                              class: "record-table__num"
                            }, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", null, _toDisplayString(row.share.label), 1),
                                _createElementVNode("span", _hoisted_20, [
                                  _createElementVNode("span", {
                                    "data-test": "share-fill",
                                    class: "products__fill",
                                    style: _normalizeStyle({ width: row.share.width })
                                  }, null, 4)
                                ])
                              ])
                            ], 8, _hoisted_18),
                            _createElementVNode("td", {
                              "data-test": "cell",
                              "data-label": LABELS.lastOrdered,
                              class: "record-table__num record-table__muted"
                            }, _toDisplayString(_unref(formatServerDay)(row.last_ordered_on)), 9, _hoisted_21)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (!__props.range)
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _createVNode(ReportDateRangeFilter, {
                  options: PRODUCTS_DATE_RANGE_OPTIONS,
                  selected: _unref(selectedDateRange),
                  "selected-label": _unref(selectedDateRangeLabel),
                  "custom-range": _unref(customDateRange),
                  onChange: onDateRangeChange
                }, null, 8, ["selected", "selected-label", "custom-range"])
              ]),
              key: "0"
            }
          : undefined,
        (rows.value.length > 0)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createElementVNode("span", _hoisted_22, _toDisplayString(summaryLabel.value), 1)
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["title"]))
    : _createCommentVNode("", true)
}
}

}